import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

class CustomizedXAxisTick extends PureComponent {
  render() {
    const { x, y, payload } = this.props;
    let names = payload.value.split(' ');
    return (
      <g>
        <g transform={`translate(${x},${y})`}>
          <text
            x={0}
            y={5}
            dy={5}
            textAnchor="middle"
            fill="#565a5c"
            color="#565a5c"
            fontSize={`${_.getIsMobileDevice() ? '9px' : '12px'}`}
            fontFamily="felix-medium"
          >
            {names[0]}
          </text>
        </g>
        <g transform={`translate(${x},${y})`}>
          <text
            x={0}
            y={17}
            dy={5}
            textAnchor="middle"
            fill="#565a5c"
            fontSize={`${_.getIsMobileDevice() ? '9px' : '12px'}`}
            fontFamily="felix-medium"
          >
            {`'${names.length > 1 && names[1].slice(2, 4)}`}
          </text>
        </g>
      </g>
    );
  }
}

CustomizedXAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.object
};

CustomizedXAxisTick.defaultProps = {
  x: 0,
  y: 0,
  payload: {}
};

export default CustomizedXAxisTick;
